<div
	class="item-content-wrap"
	[skl-menu-side]="item.submenu!"
	[skl-menu-side-active]="item.isActive! && !disabled"
	[skl-menu-side-context]="context"
	(skl-menu-side-close-parent)="onClose($event)">
    <div class="item-content" [ngClass]="getClassNames()">
		<i [ngClass]="item.icon"></i>
		<div class="item-content__label">{{item.label}}</div>
		<skl-icon name="angle-right" class="align--right text--font-smaller"></skl-icon>
    </div>
</div>